import { createAction } from "@reduxjs/toolkit";

enum UiActionTypes {
  SET_HIDE_HEADER = "[UI] SET HIDE HEADER",
}

export const setHideHeaderActionCreator = createAction<boolean>(UiActionTypes.SET_HIDE_HEADER);
